import { SurveyQuestionElementBase } from "survey-react-ui";

import Map from "./Map";
import { TailSpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { RootState } from "store";

export const getGpsDataProperties = [
  {
    name: "_id",
    category: "general",
    visibleIndex: 2,
  },
  {
    name: "showMap:boolean",
    category: "general",
    default: true,
    visible: false,
  },
];
export default class SurveyGetGpsDataQuestion extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);

    this.state = { value: this.question.value };
  }

  get question() {
    return this.questionBase;
  }

  get value() {
    return this.question.value;
  }

  renderInput() {
    return <div>ITS a get gps data componenet and render will be soon!</div>;
  }

  renderElement() {
    return (
      <div>
        <div>
          <div className="grid items-end gap-4 mb-6 md:grid-cols-3">
            <div>
              <label
                htmlFor="Latitude"
                style={{
                  fontStyle: "normal",
                  fontWeight: "600px",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontFamily: "Open sans",
                  color: "#6f747b",
                }}
                className="block mb-2 dark:text-white"
              >
                Latitude
                <span
                  data-key="req-text"
                  className="sd-question__required-text"
                  aria-hidden="true"
                >
                  *
                </span>
              </label>
              <input
                type="text"
                style={{
                  border: "2px solid #bdc0c4",
                }}
                id="Latitude"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="Longitude"
                style={{
                  fontStyle: "normal",
                  fontWeight: "600px",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontFamily: "Open sans",
                  color: "#6f747b",
                }}
                className="block mb-2 dark:text-white"
              >
                Longitude
                <span
                  data-key="req-text"
                  className="sd-question__required-text"
                  aria-hidden="true"
                >
                  *
                </span>
              </label>
              <input
                type="text"
                style={{
                  border: "2px solid #bdc0c4",
                }}
                id="Longitude"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <button
              className="get-gps-data"
              type="button"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 12C16 14.2091 14.2091 16 12 16C9.7909 16 8 14.2091 8 12C8 9.7909 9.7909 8 12 8C14.2091 8 16 9.7909 16 12Z"
                  fill="white"
                />
                <path
                  d="M21.1667 11.1667H20.2909C19.8992 7.2359 16.7641 4.10082 12.8333 3.70914V2.83328C12.8333 2.3734 12.4608 2 12 2C11.5392 2 11.1667 2.3734 11.1667 2.83328V3.70914C7.2359 4.10078 4.10082 7.2359 3.70914 11.1667H2.83328C2.37246 11.1667 2 11.54 2 12C2 12.46 2.37246 12.8333 2.83328 12.8333H3.70914C4.10156 16.7641 7.2359 19.8992 11.1667 20.2909V21.1667C11.1667 21.6266 11.5392 22 12 22C12.4608 22 12.8333 21.6266 12.8333 21.1667V20.2909C16.7641 19.8984 19.8992 16.7641 20.2909 12.8333H21.1667C21.6275 12.8333 22 12.46 22 12C22 11.54 21.6275 11.1667 21.1667 11.1667ZM12.8217 18.6109C12.7916 18.1783 12.4408 17.8333 12 17.8333C11.5592 17.8333 11.2084 18.1783 11.1783 18.6109C8.15996 18.2375 5.76328 15.8408 5.39004 12.8225C5.82246 12.7916 6.16672 12.44 6.16672 12C6.16672 11.56 5.82246 11.2084 5.38914 11.1783C5.7625 8.15996 8.15922 5.76328 11.1775 5.39004C11.2084 5.82168 11.5592 6.16672 12 6.16672C12.4408 6.16672 12.7916 5.82172 12.8217 5.38914C15.84 5.7625 18.2367 8.15922 18.61 11.1775C18.1775 11.2084 17.8333 11.56 17.8333 12C17.8333 12.44 18.1775 12.7916 18.6109 12.8217C18.2367 15.8408 15.8408 18.2367 12.8217 18.6109Z"
                  fill="white"
                />
              </svg>
              Get GPS Data
            </button>
          </div>
        </div>
        <GetGpsDataMapPreview question={this.question} />
      </div>
    );
  }
}

const GetGpsDataMapPreview = ({ question }: any) => {
  const { getGpsDatas, isRefreshingGeographies } = useSelector(
    (state: RootState) => state.surveyJS,
  );
  const questionId = question._id ?? question.id ?? question.rdx_id;
  const currentGetGpsData = getGpsDatas?.find(
    (ele: any) => ele.id == questionId,
  );
  const showMap = currentGetGpsData?.showMap ?? question.showMap ?? true;

  if (!showMap) {
    return null;
  }

  if (isRefreshingGeographies) {
    return (
      <div className="loader h-[400px] justify-center items-center flex w-full">
        <TailSpin
          height="50"
          width="50"
          color="#005C89"
          ariaLabel="tail-spin-loading"
          radius="2"
          wrapperStyle={{}}
          wrapperClass="tailspin-loader"
          visible={true}
        />
      </div>
    );
  }

  return <Map questionId={questionId} />;
};
